import React from "react";
import { LocalizationProvider } from "@progress/kendo-react-intl";
import { ConfigProvider } from "antd";

import es_ES from "antd/es/locale/es_ES";
import en_US from "antd/es/locale/en_US";
import pt_BR from "antd/es/locale/pt_BR";

import CustomIntlEmbeddedProvider from "./CustomIntlEmbeddedPrivider";
import { I18nProviderBase } from "./I18nProvider";

export class I18nEmbeddedProvider extends I18nProviderBase {
  render() {
    let locale = localStorage.getItem("locale");
    if (!locale) {
      locale = "pt-BR";
    }
    let language = !locale ? null : locale.substr(0, 2);

    const antdLocale =
      locale === "en-US" ? en_US : locale === "es-ES" ? es_ES : pt_BR;

    return (
      <CustomIntlEmbeddedProvider locale={locale}>
        <LocalizationProvider language={language}>
          <ConfigProvider locale={antdLocale} renderEmpty={() => <div></div>}>
            {this.props.children}
          </ConfigProvider>
        </LocalizationProvider>
      </CustomIntlEmbeddedProvider>
    );
  }
}
